import React from "react";
import { useWatch } from "react-hook-form";
import { Grid } from "@mui/material";
import {
  ArrayInput,
  FormDataConsumer,
  NumberInput,
  ReferenceInput,
  required,
  SelectInput,
  SimpleFormIterator,
} from "react-admin";
import { InternshipPlanScheduleTypes } from "utils/constants";
import { graduationRequests } from "api/graduationApi";
import RoomInput from "server/components/Fields/RoomInput";
import { settings } from "app";
import CustomTimeOnlyInput from "server/components/Fields/CustomTimeOnlyInput";
import sessionExamsHelper from "components/AcademicYears/Exams/helper";
import { InternshipSessionInput } from "server/components/Fields/InternshipSessionInput";
import AcademicYearInput from "components/LearningActivity/CreateWeeklySchedule/components/Inputs/AcademicYearInput";
import { administrationRequests } from "api/administrationApi";

const CreateForm = ({ filters }) => {
  const formAcademicYearId = useWatch({ name: "academicYearId" });
  const formStructuralUnitId = useWatch({ name: "structuralUnitId" });
  const formPlanId = useWatch({ name: "planId" });

  const academicYearId = formAcademicYearId ?? filters?.academicYearId;
  const structuralUnitId = formStructuralUnitId ?? filters?.structuralUnitId;
  const planId = formPlanId ?? filters?.formPlanId;

  return (
    <>
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={6}
        >
          <AcademicYearInput withoutLanguage />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <ReferenceInput
            source="structuralUnitId"
            reference={administrationRequests.getStructuralUnitsSelect()}
            filter={{ filterByUser: true }}
          >
            <SelectInput
              label="Структурна единица"
              optionText="name"
              validate={required()}
            />
          </ReferenceInput>
        </Grid>
        {structuralUnitId && (
          <>
            <Grid
              item
              xs={12}
              md={6}
            >
              <InternshipSessionInput
                key={structuralUnitId}
                filter={{ structuralUnitId, academicYearId }}
              />
            </Grid>

            <Grid
              item
              xs={12}
              md={6}
            >
              <ReferenceInput
                source="planId"
                reference={graduationRequests.getInternshipPlansSelect()}
              >
                <SelectInput
                  label="Стажантски план"
                  optionText="name"
                  emptyText={false}
                />
              </ReferenceInput>
            </Grid>
          </>
        )}
        {planId && (
          <Grid
            item
            xs={12}
            md={4}
          >
            <ReferenceInput
              source="disciplineId"
              reference={graduationRequests.getPlanDisciplinesSelect(planId)}
              filter={{ planScheduleType: InternshipPlanScheduleTypes.FreeHourSelection }}
            >
              <SelectInput
                label="Дисциплина"
                validate={required()}
                optionText="nameBg"
              />
            </ReferenceInput>
          </Grid>
        )}
        <Grid
          item
          xs={12}
          md={4}
        >
          <RoomInput
            source="roomId"
            isRequired={true}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <NumberInput
            source="roomCapacity"
            label="Капацитет"
            validate={required()}
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <ArrayInput
            source="intervals"
            label="Времеви интервал"
            defaultValue={[{}]}
          >
            <SimpleFormIterator
              disableReordering
              disableClear
              inline
              sx={settings.style.iteratorWithoutGap}
            >
              <FormDataConsumer>
                {({ scopedFormData }) => (
                  <Grid
                    container
                    spacing={2}
                  >
                    <Grid
                      item
                      xs={12}
                      md={3}
                    >
                      <CustomTimeOnlyInput
                        source="from"
                        label="Начало"
                        required={true}
                        validate={() =>
                          sessionExamsHelper.validateTimeSlots({
                            startTime: scopedFormData?.from,
                            endTime: scopedFormData?.to,
                          })
                        }
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={3}
                    >
                      <CustomTimeOnlyInput
                        source="to"
                        label="Край"
                        required={true}
                        validate={() =>
                          sessionExamsHelper.validateTimeSlots({
                            startTime: scopedFormData?.from,
                            endTime: scopedFormData?.to,
                          })
                        }
                      />
                    </Grid>
                  </Grid>
                )}
              </FormDataConsumer>
            </SimpleFormIterator>
          </ArrayInput>
        </Grid>
      </Grid>
    </>
  );
};

export default CreateForm;
